<app-prompt-modal
[open]="open"
title="Logout"
message="Are you sure you want to logout?"
(dismiss)="onCancel()"
confirmHref="/logout"
confirmLabel="Continue"
></app-prompt-modal>